module.exports = __webpack_public_path__ + "img/IMG_0328_L_Foamcore.ac508b4d.jpg";